// import HeaderVideo from "../images/promotion.mp4";
//import HeaderVideo from "../images/xmas_2024.mp4";
import Nav from "./Nav";
import "./styles/Home.css";
// import Welcome from "./Welcome";
import SlushFlavours from "./SlushFlavours";
import Slider from "./Slider";
import Wave from "./Wave";
import IconBar from "./IconBar";
import Desserts from "./Desserts";
// import Stores from "./Stores";
import MenuBar from "./MenuBar";
import Footer from "./Footer";
import App from "./App";
import OurStory from "./OurStory";
import InternationalProducts from "./InternationalProducts";
import Promotions from "./Promotions";
// import Xmas from './xmas/Xmas';

export default function Home() {
    return (
        <section className="Home">
            <Nav />
            {/* <Welcome /> */}
            <Promotions />
            <InternationalProducts />
            <SlushFlavours />
            <Wave />
            <App />
            <IconBar />
            <Desserts />
            <MenuBar />
            <Slider />
            <OurStory />
            <Footer />
        </section>
    );
}
